export const GET_CONTAINER_SIZES = "GET_CONTAINER_SIZES";
export const GET_CONTAINER_SIZE = "GET_CONTAINER_SIZE";
export const ADD_CONTAINER_SIZE = "ADD_CONTAINER_SIZE";
export const DELETE_CONTAINER_SIZE = "DELETE_CONTAINER_SIZE";
export const UPDATE_CONTAINER_SIZE = "UPDATE_CONTAINER_SIZE";
